import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cloud",
  "use": "icon-cloud-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cloud\"><defs><style type=\"text/css\"></style></defs><path d=\"M1075.2 453.2c8.2-21.4 12.8-44.8 12.8-69.2 0-106-86-192-192-192-39.4 0-76.2 12-106.6 32.4C734 128.4 630.6 64 512 64c-176.8 0-320 143.2-320 320 0 5.4 0.2 10.8 0.4 16.2C80.4 439.6 0 546.4 0 672c0 159 129 288 288 288h736c141.4 0 256-114.6 256-256 0-123.8-88-227.2-204.8-250.8z\" p-id=\"12582\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol